// extracted by mini-css-extract-plugin
export default {"notfound":"notfound__3WT8o"};